export default __webpack_public_path__ + "static/assets/d7e27567f071797be230fe98576ce015.svg";